import { useCallback, useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '../store';
import {
  activateAvisoThunk,
  AvisoMutationAction,
  clearFilters,
  clearMutationError,
  clearSelectedDetail,
  createAvisoThunk,
  deactivateAvisoThunk,
  fetchAvisoDetailThunk,
  fetchAvisosThunk,
  setFilters,
  setLimit,
  setPage,
  updateAvisoThunk,
} from '../store/slices/avisos.slice';
import {
  AvisosFilters,
  CreateAvisoPayload,
  UpdateAvisoPayload,
} from '../types/aviso';

export const useAvisos = () => {
  const dispatch = useAppDispatch();
  const state = useAppSelector((s) => s.avisos);

  const refresh = useCallback(() => {
    return dispatch(
      fetchAvisosThunk({
        page: state.page,
        limit: state.limit,
        ...state.filters,
      }),
    );
  }, [dispatch, state.page, state.limit, state.filters]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return {
    items: state.items,
    page: state.page,
    limit: state.limit,
    total: state.total,
    totalPages: state.totalPages,
    filters: state.filters,
    status: state.status,
    error: state.error,
    selectedDetail: state.selectedDetail,
    detailStatus: state.detailStatus,
    detailError: state.detailError,
    mutating: state.mutating,
    mutationError: state.mutationError,
    refresh,
    setFilters: (filters: AvisosFilters) => dispatch(setFilters(filters)),
    clearFilters: () => dispatch(clearFilters()),
    setPage: (page: number) => dispatch(setPage(page)),
    setLimit: (limit: number) => dispatch(setLimit(limit)),
    openDetail: (id: string) => dispatch(fetchAvisoDetailThunk(id)),
    closeDetail: () => dispatch(clearSelectedDetail()),
    create: (payload: CreateAvisoPayload) => dispatch(createAvisoThunk(payload)),
    update: (id: string, payload: UpdateAvisoPayload) =>
      dispatch(updateAvisoThunk({ id, payload })),
    activate: (id: string) => dispatch(activateAvisoThunk(id)),
    deactivate: (id: string) => dispatch(deactivateAvisoThunk(id)),
    clearMutationError: () => dispatch(clearMutationError()),
    isMutating: (id: string, action: AvisoMutationAction) =>
      state.mutating?.id === id && state.mutating?.action === action,
  };
};
